import React from 'react';
import { LoadingSpinnerProps } from './LoadingSpinner.types';

const sizeClasses: Record<LoadingSpinnerProps['size'], string> = {
  sm: 'w-3 h-3',
  md: 'w-5 h-5',
  lg: 'w-8 h-8',
  xl: 'w-12 h-12',
};

const colorClasses: Record<LoadingSpinnerProps['color'], string> = {
  blue: 'border-navy-600 border-t-blue-500',
  yellow: 'border-navy-600 border-t-yellow-400',
  white: 'border-white/30 border-t-white',
  green: 'border-navy-600 border-t-green-500',
  red: 'border-navy-600 border-t-red-500',
};

export function LoadingSpinner({
  size = 'md',
  color = 'blue',
  className = '',
}: LoadingSpinnerProps) {
  const sizeClass = sizeClasses[size];
  const colorClass = colorClasses[color];
  const borderWidth = size === 'sm' ? 'border-2' : 'border-4';

  const combinedClasses = `${sizeClass} ${borderWidth} ${colorClass} rounded-full animate-spin ${className}`.trim();

  return <div className={combinedClasses} aria-label="Carregando" role="status" />;
}

